import moment from 'moment'
import { hostname } from '@/utils/hostname'
// import relatorioChamadasHttpService from '../_services/RelatorioChamadasHttpService'

const actionObject = {
  DiscarGrupo: 'Discar para grupo de atendimento',
  DiscarRamal: 'Discar para ramal',
  DiscarTronco: 'Discar para tronco',
  TocarUra: 'Discar para URA',
  TocarSinalDeOcupado: 'Tocar sinal de ocupado',
  TocarAudio: 'Tocar áudio',
  ValidarSenha: 'Validar senha',
  ChangeToTrueActiveRegex: 'Ativar expressão regular',
  ChangeToFalseActiveRegex: 'Desativar expressão regular',
  DiscarFila: 'Discar para fila',
  DiscarAgente: 'Discar para operador',
  DiscarConferencia: 'Discar para conferência',
}

export const listaRelatorioChamadasMethods = {
  getAudio(audio) {
    return `https://${hostname()}/backend/asterisk/gravacao/player/${audio}`
  },
  getAudioConference(audio) {
    return `https://${hostname()}/backend/asterisk/relatorios/download/conferencia/${audio}`
  },
  timeToDate(time) {
    return moment(time, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
  },

  showAcao(acao) {
    const arrayAcao = acao.split('\\')
    const ultimaPosicao = arrayAcao.length - 1
    const acaoFormatada = actionObject[`${arrayAcao[ultimaPosicao]}`]
    return acaoFormatada
  },

  verificaTronco(atendente, numeroOrigem, numeroDestino, acao) {
    if (acao === 'DiscarConferencia' && atendente) {
      return this.getDescriptionSpecificConferencia(atendente)
    }
    if (acao === 'DiscarConferencia' && !atendente) {
      return 'Pendente'
    }
    if (typeof atendente === 'undefined') {
      return 'Não atendida'
    }
    if (typeof atendente.split('-')[2] !== 'undefined') {
      return atendente.split('-')[0]
    }
    if (atendente.includes('Local')) {
      return atendente.split('@')[0].split('/')[1]
    }
    if (typeof atendente.split('-')[1] === 'undefined') {
      return atendente
    }

    const verificacao = atendente.split('-')[0].includes('.')
    if (!verificacao) {
      return atendente.split('-')[0].split('/')[1]
    }
    if (numeroOrigem.length >= 8) {
      return numeroOrigem
    }

    return numeroDestino
  },

  ligacaoCaiu(hangupSource, numeroDestino) {
    if(hangupSource !== null){
      if (hangupSource.includes('PJSIP/')) {
        if (hangupSource.includes('.')) {
          return numeroDestino
        }
        return hangupSource.split('-')[0].split('/')[1]
      }
    }


    return hangupSource
  },

  // async exportExcel() {
  //   const params = {
  //     dataHoraInicio: this.form.dataHoraInicio,
  //     dataHoraFim: this.form.dataHoraFim,
  //     numeroOrigem: this.form.numeroOrigem,
  //     numeroDestino: this.form.numeroDestino,
  //     centroDeCusto: this.form.centroDeCusto,
  //     status: this.form.status,
  //   }

  //   window.open(relatorioChamadasHttpService.exportPdf(params))
  // },
}
